import { PANJWE } from '@visa/lib-webcrypto';
import { VISA } from '../constants/common-enums';
import { getCertificates, getCertificateKid, getCertificatePublicKey } from './certificate-utils';
import logger from './collapsed-logger';
import isEmptyObject from './is-empty-object';

/**
 * Helper to encrypt the consumer object.
 *
 * NOTE: consumer object should be validated prior to calling this function
 *
 * @param {object} consumerInfo obect with first name, last name, phone, email, etc
 * @return {object} encrypted consumer info
 *
 * ex.
 *
 *   let encryptedConsumerObject;
 *   try {
 *     encryptedConsumerObject = await encryptConsumerObject(consumer);
 *   } catch (e) {
 *     // fail with some kind of error
 *   }
 *
 */
async function encryptConsumerInfo(consumerInfo) {
  // retun null if consumerInfo is an empty object
  if (isEmptyObject(consumerInfo)) {
    return null;
  }

  const certs = getCertificates();
  const publicKey = getCertificatePublicKey(certs, VISA);
  const kid = getCertificateKid(certs, VISA);
  logger('encryptConsumerInfo::certificates', certs);

  // exponent needs to be an integer, otherwise JOSE pukes
  publicKey.e = parseInt(publicKey.e, 10);
  try {
    const crypt = new PANJWE(kid, publicKey);

    // the WebCrypto API is asynchronous, Promise-based in execution.
    const encryptedConsumerInfo = await crypt.encrypt(JSON.stringify(consumerInfo));
    logger('encryptConsumerInfo', encryptedConsumerInfo);

    return encryptedConsumerInfo; // encrypted consumer info
  } catch (e) {
    logger('encryptConsumerInfo: Error encrypting consumer object', e);
    return null;
  }
}

export default encryptConsumerInfo;
